// extracted by mini-css-extract-plugin
export default {"root":"IconFarmersMarket_root__gIALV"};